<select class="form-control" [(ngModel)]="cinema" (ngModelChange)="onChange($event)" [compareWith]="cinemaSelectCompare">
  <option *ngFor="let item of cinemaList" [ngValue]="item">{{item.name}}</option>
</select>